export const PENDING = {
  FETCH: "PENDING.FETCH",
  FETCH_SUCCESS: "PENDING.FETCH_SUCCESS",
  FETCH_ERROR: "PENDING.FETCH_ERROR",
  ACCEPT: "PENDING.ACCEPT",
  CONCILE: "PENDING.CONCILE",
  SET_FILTER: "PENDING.SET_FILTER",
  SET_PAGE_INDEX: "PENDING.SET_PAGE_INDEX",
  SET_SORT_COLUMN: "PENDING.SET_SORT_COLUMN",
  SET_SORT_DESC: "PENDING.SET_SORT_DESC",
  DELETE_TRANSFER: "PENDING.DELETE_TRANSFER",
  DELETE_TRANSFER_ALL: "PENDING.DELETE_TRANSFER_ALL"
};

export default PENDING;
